<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [title]="'Workflow Run'"
      [class]="extraClass"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>

    <tidy-card>
      <tidy-row class="vertical-align-middle">
        <tidy-text
          [header]="run?.workflow_name" />
      </tidy-row>
      <tidy-row class="vertical-align-center">
        <tidy-image
          [src]="run?.status === 'failed' ? 'assets/img/block.svg' : 'assets/img/checkmark.svg'"
          class="body-size" />
        <tidy-text
          [body]="run?.status | titlecase" />
      </tidy-row>
      <tidy-row>
        <tidy-text
          [helper]="(run?.status_updated_at | parseDateTime:'MMM d':'local') + ' ' + (run?.status_updated_at | parseDateTime:'h:mma':'local')" />
      </tidy-row>
      <tidy-row class="extra-top-padding extra-bottom-padding">
        <tidy-divider />
      </tidy-row>
      <tidy-row class="extra-bottom-padding vertical-align-center">
        <tidy-image
          [src]="'assets/img/play.svg'"
          class="title-size" />
        <tidy-text
          [header]="'Trigger'" />
      </tidy-row>
      <tidy-row class="vertical-align-center extra-bottom-padding">
        <tidy-image
          [src]="run?.trigger_icon_url"
          class="title-size" />
        <tidy-text
          [body]="run?.trigger_name" />
      </tidy-row>
      <tidy-row class="extra-bottom-padding">
          <pre style="display: inline;
          font-family: 'Inter', Arial, sans-serif;
          font-weight: 300;
          font-size: 14px;
          color: var(--tidy-text-primary)">{{triggerOutputs}}</pre>
      </tidy-row>
      @for (action of run?.workflow_version_action_runs; track action; let last = $last; let actionIndex = $index) {
        <tidy-row class="vertical-align-center extra-bottom-padding">
          <tidy-image
            [src]="'assets/img/check.svg'"
            class="title-size" />
          <tidy-text
            [header]="'Action'" /><span>&nbsp;</span>
            <tidy-text
              [header]="((actionIndex | translate) + (1 | translate))" />
          </tidy-row>
          <tidy-row class="vertical-align-center" [ngClass]="!last ? 'extra-bottom-padding' : ''">
            <tidy-image
              [src]="action?.action_icon_url"
              class="title-size" />
            <tidy-text
              [body]="action?.action_name" />
          </tidy-row>
          @if (action?.error?.message) {
            <tidy-row class="vertical-align-center" [ngClass]="!last ? 'extra-bottom-padding' : ''">
              <tidy-text
                [body]="'Error:'"
                class="red" /><span>&nbsp;</span>
                <tidy-text
                  [body]="action?.error?.message"
                  class="red" />
              </tidy-row>
            }
            <tidy-row>
              <div>
                <tidy-text
                  [body]="'Input data:'" /><span>&nbsp;</span>
                  @for (input_value of action?.input_values | keyvalue; track input_value; let i = $index) {
                    <tidy-row>
                      <tidy-text [body]="'• ' + input_value.key + ': ' + input_value.value" />
                    </tidy-row>
                  }
                </div>
              </tidy-row>
            }
          </tidy-card>

        </tidy-wrapper>
      </ng-template>

      @if (!isRightSideContent) {
        <app-scroll-wrapper [templateContent]="content" />
      }

      @if (isRightSideContent) {
        <ion-content class="ion-content-right-column">
          <ng-container *ngTemplateOutlet="content" />
        </ion-content>
      }
